import { render, staticRenderFns } from "./updateemailverify.vue?vue&type=template&id=29672c60&"
import script from "./updateemailverify.vue?vue&type=script&lang=js&"
export * from "./updateemailverify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2044461438/src/tacotrade-platform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29672c60')) {
      api.createRecord('29672c60', component.options)
    } else {
      api.reload('29672c60', component.options)
    }
    module.hot.accept("./updateemailverify.vue?vue&type=template&id=29672c60&", function () {
      api.rerender('29672c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/updateemailverify.vue"
export default component.exports